// extracted by mini-css-extract-plugin
module.exports = {"totalWrapper":"_20dRekAtBSJrSqHlEa40kQ==","row":"fO4pfzzFf7AaiNxGz9h0Rg=="};